module.exports = __webpack_public_path__ + "static/media/typeorm.ac0df9c8.png";